import { styled } from '@linaria/react';

import { COLORS_MAP, type CommonProps } from '../constants';

export const SIZES = [undefined, 'L', 'M'] as const;
export type TSize = (typeof SIZES)[number];

const FONT_SIZES = {
	M: '3.6rem',
	L: '4.8rem',
};

const LINE_HEIGHTS = {
	M: '4.4rem',
	L: '6.4rem',
};

export const Display = styled.p<CommonProps<TSize>>`
	color: ${({ color }) => (color ? COLORS_MAP[color] : 'inherit')};
	font-size: ${({ size = 'M' }) => FONT_SIZES[size]};
	font-weight: var(--font-weight-medium);
	line-height: ${({ size = 'M' }) => LINE_HEIGHTS[size]};

	text-align: ${({ align }) => align ?? 'center'};
	text-transform: ${({ transform }) => transform ?? 'inherit'};
	text-wrap: balance;
	white-space: ${({ multiline }) => (multiline ? 'pre-wrap' : 'inherit')};
	word-break: ${({ multiline }) => (multiline ? 'break-word' : 'inherit')};

	&::first-letter {
		text-transform: ${({ capitalizeFirstLetter }) =>
			capitalizeFirstLetter ? 'uppercase' : 'inherit'};
	}
`;
